import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Stack,
  Textarea,
  Text,
  Tag,
  TagLabel,
  useToast,
  VStack,
  Center,
  AlertDialogBody,
  AlertDialogHeader,
} from "@chakra-ui/react";

import JsonRender from "../../../renderer/JsonRender";
import { useCallback, useEffect, useState } from "react";
import {
  useDeletePractice,
  useGenerateLesson,
  useGetAlterante,
  useGetModule,
  useGetTools,
  usePublishPractice,
  useSavePractice,
} from "./../api";
import Images from "../components/Images";
import { assets } from "../../../assets";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import { useAppDispatch, useAppSelector } from "../../../store";
import DropdownWithSearch from "../../../components/Inputs/DropDownSelector";
import { DeleteIcon } from "@chakra-ui/icons";
import Dialog from "../../../components/Dialogs/Dialog";
import { Role, useAuth } from "../../../Providers/AuthProvider";
import {
  clearnPractice,
  initialPractice,
  updatePracticeState,
} from "../../../store/slices/practiceSlice";

const tags = ["Begineer", "Advanced", "Intuitive"];

const Practice = () => {
  const [isImageDrawerOpen, setIsImageDrawerOpen] = useState(false);
  const {
    currentPractice,
    alternateRequirements,
    currentSelectedContentId,
    alterantesOptions,
    rightPanel,
    allPractices,
    originalPractices,
  } = useAppSelector((s) => s.practice);
  const { role } = useAuth();
  const [selectedTool, setSelectedTool] = useState("");
  const dispach = useAppDispatch();
  const generateLesson = useGenerateLesson();
  const savePractice = useSavePractice();
  const alternateContent = useGetAlterante();
  const publishPractice = usePublishPractice();
  const removePractice = useDeletePractice();
  const { courseId, moduleId } = useParams();
  const { data: toolsData } = useGetTools();
  const [dialog, setDialog] = useState<"remove" | "publish" | null>(null);
  const [currentQuizIndex, setCurrentQuizIndex] = useState<number>(0);
  const toast = useToast();

  const modules = useGetModule(moduleId ?? "");
  const navigate = useNavigate();

  useEffect(() => {
    if (modules.data) {
      dispach(
        updatePracticeState({
          originalPractices: modules.data.practices as any,
          allPractices: modules.data.practices as any,
        })
      );
    }
  }, [modules.data, modules.isSuccess]);

  const showToast = (status: boolean, title: string, desc?: string) =>
    toast({
      title,
      position: "top",
      description: desc,
      status: status ? "success" : "error",
      duration: 5000,
      isClosable: true,
    });

  const handleFetchLesson = useCallback(async () => {
    generateLesson.mutate(
      {
        lessonName: currentPractice?.title!,
        requirements: [],
        customLesson: currentPractice?.customPractice!,
      },
      {
        onSuccess: (res: any) => {
          console.log(res, "--lesson");
          dispach(
            updatePracticeState({
              currentPractice: { ...currentPractice, content: res.lesson },
            })
          );
          showToast(true, "Genderated Successfully");
        },
        onError: (err) => {
          showToast(false, "Failed to generate Practice");
          console.info(err, "---ERROR TO FETCH COURSE");
        },
      }
    );
  }, [currentPractice]);

  const handleAlternateContent = useCallback(async () => {
    alternateContent.mutate(
      {
        lessonName: currentPractice?.title,
        tool: selectedTool,
        requirement: alternateRequirements,
      },
      {
        onSuccess: (res) => {
          dispach(
            updatePracticeState({
              alterantesOptions: res.lesson,
            })
          );
        },
        onError: (err) => {
          console.info(err, "---ERROR TO Alternate");
        },
      }
    );
  }, [currentPractice, alternateRequirements, selectedTool]);

  const handleContentClick = useCallback(
    (contentId: number, event: "add" | "click" | "remove") => {
      if (event === "click") {
        dispach(
          updatePracticeState({
            rightPanel: "alternate",
            currentSelectedContentId: contentId,
          })
        );
      }
      if (event === "add") {
        const newContent = [...currentPractice.content];

        newContent.splice(contentId + 1, 0, {} as IConfig);
        setCurrentQuizIndex((p) => p + 1);
        dispach(
          updatePracticeState({
            currentPractice: { ...currentPractice, content: newContent },
          })
        );
      }
      if (event === "remove") {
        const newContent = [...currentPractice.content];

        newContent.splice(contentId, 1);

        if (currentQuizIndex > 0) {
          setCurrentQuizIndex((p) => p - 1);
        }

        dispach(
          updatePracticeState({
            currentPractice: { ...currentPractice, content: newContent },
          })
        );
      }
    },
    [currentPractice.content]
  );

  const handleAlternateSelect = useCallback(
    (alternateElemIndex: number) => {
      const alternateContent = alterantesOptions[alternateElemIndex];

      const newContentList = [...currentPractice.content];
      newContentList[currentSelectedContentId!] = alternateContent;

      dispach(
        updatePracticeState({
          currentPractice: { ...currentPractice, content: newContentList },
        })
      );
    },
    [currentPractice, alterantesOptions, currentSelectedContentId]
  );

  const clearCurrentAddChange = useCallback(() => {
    const newContentList = [...currentPractice.content];
    const currentLessonIndex = originalPractices.findIndex(
      (l) => l._id === currentPractice._id
    );

    if (currentLessonIndex > 0) {
      newContentList[Number(currentSelectedContentId)] =
        originalPractices[currentLessonIndex].content[currentLessonIndex];

      dispach(
        updatePracticeState({
          alterantesOptions: [],
          currentPractice: { ...currentPractice, content: newContentList },
        })
      );
    }
  }, [currentPractice, currentSelectedContentId, originalPractices]);

  const handleSavePractice = useCallback(async () => {
    savePractice.mutate(
      { ...currentPractice, module: moduleId! },
      {
        onSuccess: () => {
          showToast(true, "Saved successfully");
          modules.refetch();
        },
        onError: (err) => {
          console.info(err, "---ERROR TO Alternate");
          showToast(false, "Failed to save practice");
        },
        onSettled: () => {},
      }
    );
  }, [currentPractice]);

  const handlePublishLesson = useCallback(async () => {
    publishPractice.mutate(
      {
        _id: currentPractice._id!,
      },
      {
        onSuccess: () => {
          showToast(true, "published successfully");
          modules.refetch();
        },
        onError: (err) => {
          console.info(err, "---ERROR TO Alternate");
          showToast(false, "Failed to publish Practice");
        },
      }
    );
  }, [currentPractice]);

  useEffect(() => {
    return () => {
      dispach(clearnPractice());
    };
  }, []);

  const handleRemovePractice = useCallback(() => {
    removePractice.mutate(currentPractice._id, {
      onSuccess: () => {
        showToast(true, "Practice removed successfully");
        modules.refetch();
      },
      onError: (err) => {
        console.info(err, "---ERROR TO Alternate");
        showToast(false, "Failed to Remove Practice");
      },
      onSettled: () => {
        setDialog(null);
      },
    });
  }, [currentPractice._id]);

  const alternatePanel = (
    <>
      <HStack mb={"1rem"} alignItems={"center"}>
        <IconButton
          aria-label="close Practice"
          border={"1px solid white"}
          borderRadius={".9rem"}
          variant={"outline"}
          size={"md"}
          onClick={() => dispach(updatePracticeState({ rightPanel: "main" }))}
          icon={assets.iconComponents.backIcon()}
        ></IconButton>
        <Text fontSize={"lg"} fontWeight={"bold"}>
          Change Content
        </Text>
      </HStack>
      <Box>
        <Stack>
          <FormLabel>Tool Detail</FormLabel>
          <Textarea
            rows={15}
            onClick={() => {}}
            value={alternateRequirements}
            onChange={(e) =>
              dispach(
                updatePracticeState({
                  alternateRequirements: e.target.value,
                })
              )
            }
            placeholder="Details of what you need as alternative"
          ></Textarea>
          <FormLabel>Tool</FormLabel>
          <Box mb={"1rem"}>
            <DropdownWithSearch
              options={(toolsData || [])?.map((tool, i) => ({
                id: i,
                label: tool,
              }))}
              selectedOption={selectedTool}
              placeHolder="Select a tool"
              onChange={(option) => {
                setSelectedTool(option);
              }}
            />
          </Box>
          <ButtonGroup>
            <Button
              onClick={handleAlternateContent}
              isLoading={alternateContent.isPending}
            >
              Generate
            </Button>
            <Button variant={"outline"} onClick={clearCurrentAddChange}>
              Clear
            </Button>
          </ButtonGroup>
          <Divider bg={"whiteAlpha.400"} my={"1rem"} />
          <Box sx={{ zoom: "0.8" }}>
            <JsonRender
              width="100%"
              lessonId=""
              mode="selection"
              onClick={handleAlternateSelect}
              content={alterantesOptions}
            />
          </Box>
        </Stack>
      </Box>
    </>
  );

  const mainPanel = (
    <Box>
      <ButtonGroup mb={"1rem"}>
        <Button
          variant={"teronary"}
          isLoading={generateLesson.isPending}
          onClick={handleFetchLesson}
          bg={"purple.400"}
        >
          Generate new Practices
        </Button>
        {currentPractice.content.length > 0 && (
          <>
            <Button
              variant={"solid"}
              onClick={handleSavePractice}
              colorScheme="blue"
              isLoading={savePractice.isPending}
            >
              save Practice
            </Button>
            {(role === Role.SuperAdmin || role === Role.Admin) &&
              currentPractice._id && (
                <Button
                  onClick={handlePublishLesson}
                  variant={"solid"}
                  colorScheme="green"
                  isLoading={publishPractice.isPending}
                >
                  publish
                </Button>
              )}
          </>
        )}
      </ButtonGroup>
      <Box>
        <FormLabel>Pratice Name</FormLabel>
        <Input
          value={currentPractice.title}
          onChange={(e) =>
            dispach(
              updatePracticeState({
                currentPractice: { ...currentPractice, title: e.target.value },
              })
            )
          }
          placeholder="Practice name"
          type="text"
          mb={"1rem"}
        ></Input>
        <FormLabel>Practice Description</FormLabel>
        <Textarea
          value={currentPractice.customPractice}
          onChange={(e) => {
            dispach(
              updatePracticeState({
                currentPractice: {
                  ...currentPractice,
                  customPractice: e.target.value,
                },
              })
            );
          }}
          rows={25}
          mb={"1rem"}
          placeholder="Description"
        ></Textarea>
        {/* <FormLabel>requirement</FormLabel>
        <Textarea
          value={currentLesson.requirements[0]}
          onChange={(e) => {
            dispach(
              updateLessonState({
                currentLesson: {
                  ...currentLesson,
                  requirements: [e.target.value, currentLesson.requirements[1]],
                },
              })
            );
          }}
          rows={10}
          mb={"1rem"}
          placeholder="Lesson requirement"
        ></Textarea> */}
        {/* <FormLabel>Part 2 requirement</FormLabel>
        <Textarea
          value={currentLesson.requirements[1]}
          onChange={(e) => {
            dispach(
              updateLessonState({
                currentLesson: {
                  ...currentLesson,
                  requirements: [currentLesson.requirements[0], e.target.value],
                },
              })
            );
          }}
          rows={10}
          mb={"1rem"}
          placeholder="Lesson requirement"
        ></Textarea> */}
        <FormLabel>Select the Type</FormLabel>
        <HStack spacing={4}>
          {tags.map((tag: string) => (
            <Tag
              cursor={"pointer"}
              onClick={() => {
                dispach(
                  updatePracticeState({
                    currentPractice: { ...currentPractice, type: tag },
                  })
                );
              }}
              size={"lg"}
              key={tag}
              variant={tag === currentPractice.type ? "solid" : "outline"}
              colorScheme={tag === currentPractice.type ? "blue" : "neutral"}
              borderRadius="full"
            >
              <TagLabel>{tag}</TagLabel>
            </Tag>
          ))}
        </HStack>
      </Box>
      {/* <Button
    onClick={() => setDrawerOpen(false)}
    m={"1rem"}
    ms={"auto"}
    width={"fit-content"}
    variant={"secondary"}
  >
    Save
  </Button> */}
    </Box>
  );

  return (
    <Box>
      <Box
        width={"full"}
        bg={"background"}
        position={"sticky"}
        top={0}
        zIndex={"1000"}
        display={"flex"}
        justifyContent={"center"}
        px={"2rem"}
        py={"1rem"}
      >
        <Text>{modules?.data?.title} </Text>
        <Tag colorScheme="purple">PRATICE</Tag>
      </Box>
      {modules.isLoading ? (
        <Loader />
      ) : generateLesson.isPending ? (
        <Center>
          <VStack mt={"10%"}>
            <Box sx={{ zoom: "2.7" }}>
              <Loader />
            </Box>
            <Text fontSize={"xl"}>Lesson Generating...</Text>
          </VStack>
        </Center>
      ) : (
        <Box>
          {currentPractice.content.map((c, idx) => {
            return (
              <Box
                display={currentQuizIndex === idx ? "block" : "none"}
                key={idx}
              >
                <Center>
                  <Box>
                    <Text
                      my={"1rem"}
                      textAlign={"center"}
                      fontWeight={"bold"}
                      fontSize={"xl"}
                    >
                      Practice- {idx + 1}
                    </Text>
                    <Center my={"1rem"}>
                      <ButtonGroup>
                        <Button
                          variant={"solid"}
                          colorScheme="blue"
                          onClick={() => handleContentClick(idx, "click")}
                        >
                          Change
                        </Button>
                        <Button
                          variant={"solid"}
                          colorScheme="green"
                          onClick={() => handleContentClick(idx, "add")}
                        >
                          Add
                        </Button>
                        <Button
                          variant={"solid"}
                          colorScheme="red"
                          onClick={() => handleContentClick(idx, "remove")}
                        >
                          Remove
                        </Button>
                      </ButtonGroup>
                    </Center>
                    <Box>
                      {c?.props ? (
                        <JsonRender
                          mode={"practice-edit"}
                          practiceId=""
                          lessonId=""
                          content={[c]}
                        />
                      ) : (
                        <Box
                          width="25rem"
                          border={"1px dashed"}
                          borderColor={"neutral.800"}
                          height="25rem"
                          borderRadius="1rem"
                        ></Box>
                      )}
                    </Box>
                  </Box>
                </Center>
              </Box>
            );
          })}
          <Center>
            <HStack mt={"1rem"}>
              {/* <Button
                variant={"secondary"}
                onClick={() => {
                  if (currentQuizIndex > 0) {
                    setCurrentQuizIndex(currentQuizIndex - 1);
                  }
                }}
                isDisabled={currentQuizIndex === 0}
              >
                Prev
              </Button>
              <Button
                onClick={() => {
                  if (currentQuizIndex < currentLesson.content.length - 1) {
                    setCurrentQuizIndex(currentQuizIndex + 1);
                  }
                }}
                variant={"secondary"}
                isDisabled={
                  currentQuizIndex === currentLesson.content.length - 1
                }
              >
                Next
              </Button> */}
              <HStack>
                {currentPractice.content.map((_, id) => (
                  <Button
                    isDisabled={currentQuizIndex === id}
                    variant={"secondary"}
                    size={"lg"}
                    onClick={() => {
                      setCurrentQuizIndex(id);
                      dispach(updatePracticeState({ rightPanel: "main" }));
                    }}
                  >
                    {id + 1}
                  </Button>
                ))}
              </HStack>
            </HStack>
          </Center>
        </Box>
      )}

      <Box
        width={"xs"}
        bg={"neutral.950"}
        p={"1rem"}
        zIndex={"sticky"}
        position={"fixed"}
        h={"100vh"}
        overflowY={"auto"}
        top={0}
        left={0}
      >
        <Box>
          <Box mb={"1rem"}>
            <HStack>
              <IconButton
                aria-label="close lesson"
                border={"1px solid white"}
                borderRadius={".9rem"}
                variant={"outline"}
                size={"md"}
                onClick={() =>
                  navigate(`/dashboard/internal/courses/modules/${courseId}`)
                }
                icon={assets.iconComponents.backIcon()}
              ></IconButton>
              <ButtonGroup>
                <Button
                  variant={"outline"}
                  onClick={() => setIsImageDrawerOpen(true)}
                >
                  Images
                </Button>
              </ButtonGroup>
            </HStack>
          </Box>
          <Box>
            <VStack gap={".4rem"}>
              {allPractices.length === 0 && <Text>No Pratices added yet</Text>}
              {allPractices.map((les: any) => (
                <HStack
                  bg={
                    currentPractice._id === les._id ? "blue.500" : "neutral.600"
                  }
                  cursor={"pointer"}
                  width={"full"}
                  p={".5rem"}
                  borderRadius={".3rem"}
                  justifyContent={"space-between"}
                  onClick={() => {
                    dispach(updatePracticeState({ currentPractice: les }));
                  }}
                >
                  <Text>
                    {les._id === currentPractice._id
                      ? currentPractice.title
                      : les.title}
                  </Text>
                  <HStack>
                    <Tag variant={"outline"}>{les.type}</Tag>
                    <Tag>{les.status}</Tag>
                    {(role === Role.SuperAdmin || role === Role.Admin) && (
                      <IconButton
                        variant={"solid"}
                        colorScheme="red"
                        size={"sm"}
                        aria-label="delete lesson"
                        onClick={() => setDialog("remove")}
                      >
                        <DeleteIcon fontSize={"sm"} />
                      </IconButton>
                    )}
                  </HStack>
                </HStack>
              ))}
              <Button
                onClick={() => {
                  dispach(
                    updatePracticeState({ currentPractice: initialPractice })
                  );
                }}
                variant={"secondary"}
                width={"full"}
              >
                New Pratice
              </Button>
            </VStack>
          </Box>
        </Box>
      </Box>

      <Images
        isOpen={isImageDrawerOpen}
        onClose={() => setIsImageDrawerOpen(false)}
        editMode={true}
      />

      <Box
        width={"md"}
        bg={"neutral.950"}
        p={"1rem"}
        zIndex={"sticky"}
        position={"fixed"}
        h={"100vh"}
        overflowY={"auto"}
        top={0}
        right={0}
      >
        {rightPanel === "alternate" && alternatePanel}
        {rightPanel === "main" && mainPanel}
      </Box>
      <Dialog isOpen={!!dialog} onClose={() => setDialog(null)}>
        <AlertDialogHeader>
          Are you want Remove this practice?
        </AlertDialogHeader>
        <AlertDialogBody>
          <Stack gap={"1rem"}>
            <Text>{currentPractice.title}</Text>
            <ButtonGroup ms="auto">
              <Button
                isDisabled={removePractice.isPending}
                variant={"outline"}
                onClick={() => setDialog(null)}
              >
                Cancel
              </Button>

              <Button
                onClick={handleRemovePractice}
                isLoading={removePractice.isPending}
                variant={"solid"}
                colorScheme="red"
              >
                Remove
              </Button>
            </ButtonGroup>
          </Stack>
        </AlertDialogBody>
      </Dialog>
    </Box>
  );
};

export default Practice;
